import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { setRouteOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { PatientMedicationsService } from '../../patientMedications/services/patientMedications.service'

export function* getRouteOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientMedicationService = new PatientMedicationsService(serviceId)
  try {
    const routeResponse: IOptionsResponse = yield call([
      patientMedicationService,
      patientMedicationService.getRouteOptions,
    ])
    const { entity } = routeResponse
    yield put(setRouteOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getRoute() error: ${e}`))
  }
}

export function* getRouteOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getRouteOptions)
}
